import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { renderError } from "../../utils/ModuleFunctions";
import AxiosInstance from "../../utils/AxiosInstance";
import { ToastContainer, toast } from "react-toastify";
import * as Yup from "yup";
import { useParams } from "react-router-dom";

export default function AssessmentForm(props) {
	const { id } = useParams();

	const initialValues = {
		location: {
			proximity: "",
			accessibility: "",
			areaPrioritization: "",
		},

		facilities: {
			roomType: "",
			roomFurnished: "",
			studyRoom: "",
			tvRoom: "",
			internet: "",
			security: {
				functioningCCTV: "",
				electricFencing: "",
				walled: "",
				gated: "",
			},
			kitchenType: "",
		},
		utility: {
			altPower: "",
			extinguisher: "",
			meterType: "",

			waterSupply: {
				waterSource: "",
				reliability: "",
			},
			electricityPayment: "",
		},
		services: {
			porters: "",
			securityPersonnel: "",
			managers: "",
			cleaners: {
				satisfactory: "",
				fairSatisfactory: "",
			},
		},
		extraServices: {
			paidTVChannnel: "",
			airConditioner: "",
			roomSpecificTv: "",
			fridges: "",
			gasCylinder: "",
			gasSupply: "",

			cookingStove: "",
			waterHeater: "",
		},
	};

	const handleSubmit = async (values, resetForm) => {
		//Beginning of location area
		const proximity = parseFloat(values.location.proximity) || 0;
		const accessibility = parseFloat(values.location.accessibility) || 0;
		const areaPrioritization =
			parseFloat(values.location.areaPrioritization) || 0;

		const locationTotal = proximity + accessibility + areaPrioritization;

		//Beginnining of facilities area
		const kitchenType = parseFloat(values.facilities.kitchenType) || 0;
		const roomType = parseFloat(values.facilities.roomType) || 0;
		const tvRoom = parseFloat(values.facilities.tvRoom[0]) || 0;
		const internet = parseFloat(values.facilities.internet[0]) || 0;
		const studyRoom = parseFloat(values.facilities.studyRoom[0]) || 0;
		const roomFurnished = parseFloat(values.facilities.roomFurnished[0]) || 0;
		const gated = parseFloat(values.facilities.security.gated[0]) || 0;
		const walled = parseFloat(values.facilities.security.walled[0]) || 0;
		const cctv = parseFloat(values.facilities.security.functioningCCTV[0]) || 0;
		const electricFence = parseFloat(
			values.facilities.security.electricFencing[0] || 0
		);

		const facilitiesTotal =
			kitchenType +
			roomType +
			tvRoom +
			internet +
			studyRoom +
			roomFurnished +
			gated +
			walled +
			cctv +
			electricFence;

		//Beginnining of utility area
		const altPower = parseFloat(values.utility.altPower) || 0;
		const extinguisher = parseFloat(values.utility.extinguisher) || 0;
		const meterType = parseFloat(values.utility.meterType) || 0;
		const waterSource = parseFloat(values.utility.waterSupply.waterSource) || 0;
		const reliability = parseFloat(values.utility.waterSupply.reliability) || 0;
		const electricityPayment =
			parseFloat(values.utility.electricityPayment) || 0;

		const utilityTotal =
			extinguisher +
			altPower +
			meterType +
			waterSource +
			reliability +
			electricityPayment;

		//Beginnining of Services area
		const porters = parseFloat(values.services.porters) || 0;
		const securityPersonnel =
			parseFloat(values.services.securityPersonnel) || 0;
		const managers = parseFloat(values.services.managers) || 0;
		const cleaners_sat = parseFloat(values.services.cleaners.satisfactory) || 0;

		const servicesTotal = porters + securityPersonnel + managers + cleaners_sat;

		const paidTVChannel = parseFloat(values.extraServices.paidTVChannel) || 0;

		const airConditioner = parseFloat(values.extraServices.airConditioner) || 0;
		const roomSpecificTv = parseFloat(values.extraServices.roomSpecificTv) || 0;
		const fridges = parseFloat(values.extraServices.fridges) || 0;
		const gasCylinder = parseFloat(values.extraServices.gasCylinder) || 0;
		const gasSupply = parseFloat(values.extraServices.gasSupply) || 0;

		const cookingStove = parseFloat(values.extraServices.cookingStove) || 0;
		const waterHeater = parseFloat(values.extraServices.waterHeater) || 0;

		const extraSerivicesTotal =
			paidTVChannel +
			airConditioner +
			roomSpecificTv +
			fridges +
			gasCylinder +
			gasSupply +
			cookingStove +
			waterHeater;

		console.log(
			locationTotal +
				facilitiesTotal +
				utilityTotal +
				servicesTotal +
				extraSerivicesTotal
		);
		const score =
			locationTotal +
			facilitiesTotal +
			utilityTotal +
			servicesTotal +
			extraSerivicesTotal;
		try {
			const res = await AxiosInstance({
				method: "post",
				url: `/api/v1/residences/assessment`,
				headers: {
					accept: "application/json",
				},
				data: {
					id,
					score: score,
				},
			});
			resetForm();
			toast.success(res.data.message);
			// navigate("/admin/residences");
		} catch (err) {
			if (err?.response.data?.message) {
				if (err?.response?.data?.message.startsWith("Can't extract")) {
					toast.error(
						"Please provide a correct coodinates for the Longitude and the Latitude",
						{ position: "top-center" }
					);
				} else {
					toast.error(err?.response?.data?.message, { position: "top-center" });
				}
			}
		}
	};

	return (
		<>
			<div className="container">
				<FormStepper
					initialValues={initialValues}
					onSubmit={async (values, resetForm) => {
						await handleSubmit(values, resetForm);
					}}
				>
					<FormikStep
						validationSchema={Yup.object({
							location: Yup.object({
								proximity: Yup.string().required("Proximity is Required"),
								accessibility: Yup.string().required(
									"Acessibility is Required"
								),
								areaPrioritization: Yup.string().required(
									"Area Prioritization is Required"
								),
							}),
						})}
					>
						<div className="assess-card">
							<h5 className="text-center ">
								DETERMINANTS OF RESIDENCE CLASS AND PRICES
							</h5>
							<h5 className="mb-2">LOCATION</h5>
							<div className="row">
								<div className="col-md-6 col-sm-12">
									<div role="group" aria-labelledby="proximity-radio-group">
										<section>Proximity</section>
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.proximity"
												value={"8"}
											/>

											<b className="mx-2">Very Near = Less than 1km</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.proximity"
												value={"6"}
											/>
											<b className="mx-2">Near = Between 1 and 3km</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.proximity"
												value={"4"}
											/>
											<b className="mx-2">Far = Between 3 and 5km</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.proximity"
												value={"2"}
											/>
											<b className="mx-2">
												Very far = Greater than 5km with transportation
											</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.proximity"
												value={"0"}
											/>
											<b className="mx-2">
												Very far = Greater than 5km without transportation
											</b>
										</label>
										<br />
									</div>
									<ErrorMessage
										name="location.proximity"
										render={renderError}
									/>
								</div>
								<div className="col-md-6 col-sm- my-3">
									<div role="group" aria-labelledby="accessibility-radio-group">
										<section>Accessibility</section>
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.accessibility"
												value={"8"}
											/>
											<b className="mx-2">
												Very accessible (Very good road leads to the
												hostel/homestel)
											</b>
										</label>
										<br />
										<label>
											<Field
												type="radio"
												name="location.accessibility"
												value={"5"}
											/>
											<b className="mx-2">
												Accessible (possible to drive to hostel but on bad road)
											</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.accessibility"
												value={"3"}
											/>
											<b className="mx-2">
												Not accessible (Motorable road leads to hostel/homestel)
											</b>
										</label>
										<br />
										<ErrorMessage
											name="location.accessibility"
											render={renderError}
										/>
									</div>
								</div>
								<div className="col-md-6 col-sm-12 mt-4">
									<div role="group" aria-labelledby="area-radio-group">
										<section>Area Proritization</section>
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.areaPrioritization"
												value={"9"}
											/>
											<b className="mx-2">Priority Area 1 (Ayeduase)</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.areaPrioritization"
												value={"7"}
											/>
											<b className="mx-2">Priority Area 2 (Kotei)</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.areaPrioritization"
												value={"5"}
											/>
											<b className="mx-2">
												Priority Area 3 (Ayeduase New Site)
											</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.areaPrioritization"
												value={"3.0"}
											/>
											<b className="mx-2">Priority Area 4 (Bomso & Gaza)</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.areaPrioritization"
												value={"3"}
											/>
											<b className="mx-2">
												Priority Area 5 (Kentinkrono, Emina, Twumduasi)
											</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="location.areaPrioritization"
												value={"1"}
											/>
											<b className="mx-2">Priority Area 6 (Others)</b>
										</label>
									</div>
								</div>
							</div>
							<ErrorMessage
								name="location.areaPrioritization"
								render={renderError}
							/>
						</div>

						<hr className="my-3" />
					</FormikStep>
					<FormikStep
						validationSchema={Yup.object({
							facilities: Yup.object({
								roomType: Yup.string().required("Type of Room is Required"),
								kitchenType: Yup.string().required("Kitchen Type is Required"),
							}),
						})}
					>
						<div className="row">
							<div className="col-md-6 col-sm-12">
								<div role="group" aria-labelledby="facility-radio-group">
									<h3>Facilities</h3>
									<p>Room Type</p>
									<label className="label-spacing">
										<Field
											type="radio"
											name="facilities.roomType"
											value={"6"}
										/>

										<b className="mx-2">Self-Contained</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="facilities.roomType"
											value={"4"}
										/>
										<b className="mx-2">
											Combination of Self-Contained and Shared
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="facilities.roomType"
											value={"2"}
										/>
										<b className="mx-2">Shared lavatory for 2 or 3 rooms</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="facilities.roomType"
											value={"1"}
										/>
										<b className="mx-2">
											Shared lavatory for more than 3 rooms
										</b>
									</label>
									<br />
									<ErrorMessage
										name="facilities.roomType"
										render={renderError}
									/>
								</div>
							</div>
							<div className="col-md-6 col-sm- my-3">
								<div role="group" aria-labelledby="accessibility-radio-group">
									<p>Conditions</p>
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="facilities.roomFurnished"
											value={"2"}
										/>
										<b className="mx-2">
											Room furnishing: Does the room have fan, bed with
											mattress, tables, chairs?
										</b>
									</label>
									<br />
									<label>
										<Field
											type="checkbox"
											name="facilities.studyRoom"
											value={"2"}
										/>
										<b className="mx-2">
											Study Room: Does the hostel have a study room ?
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="facilities.tvRoom"
											value={"2"}
										/>
										<b className="mx-2">
											TV/Common room: Does the hostel have a TV/Common room ?
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="facilities.internet"
											value={"2"}
										/>
										<b className="mx-2">
											Internet Connectivity: Does the hostel have internet for
											students ?
										</b>
									</label>
									<br />
								</div>
							</div>
							<div className="col-md-6 col-sm-12 mt-4">
								<div role="group" aria-labelledby="area-radio-group">
									<p>Security</p>
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="facilities.security.functioningCCTV"
											value={"7"}
										/>
										<b className="mx-2">
											Presence of functioning CCTV cameras?
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="facilities.security.electricFencing"
											value={"3"}
										/>
										<b className="mx-2">Presence of electric fencing?</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="facilities.security.walled"
											value={"3"}
										/>
										<b className="mx-2">Is the hostel/homestel walled?</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="checkbox"
											name="facilities.security.gated"
											value={"3"}
										/>
										<b className="mx-2">Is the hostel/homestel gated?</b>
									</label>
									<br />
								</div>
							</div>
							<div className="col-md-6 col-sm-12 mt-4">
								<div role="group" aria-labelledby="area-radio-group">
									<p>Kitchen Type</p>
									<label className="label-spacing">
										<Field
											type="radio"
											name="facilities.kitchenType"
											value={"3"}
										/>
										<b className="mx-2">Room-specific kitchen</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="facilities.kitchenType"
											value={"1.5"}
										/>
										<b className="mx-2">Shared kitchen</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="facilities.kitchenType"
											value={"0"}
										/>
										<b className="mx-2">No Kitchen</b>
									</label>
									<br />
									<ErrorMessage
										name="facilities.kitchenType"
										render={renderError}
									/>
								</div>
							</div>
						</div>

						<hr className="my-3" />
					</FormikStep>

					<FormikStep
						validationSchema={Yup.object({
							utility: Yup.object({
								altPower: Yup.string().required(
									" Alternate Power source for Room is Required"
								),
								meterType: Yup.string().required("Meter Type is Required"),
							}),
						})}
					>
						<h2>UTILITIES</h2>
						<div className="row">
							<div className="col-md-6 col-sm-12 mt-4">
								<div role="group" aria-labelledby="area-radio-group">
									<section>
										<h5>Fire Extinguishers</h5>
										Is there fire extinguisher that have not expired?
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="utility.extinguisher"
												value={"2"}
											/>
											<b className="mx-2">Yes</b>
										</label>
										<label className="label-spacing">
											<Field
												type="radio"
												name="utility.extinguisher"
												value={"0"}
											/>
											<b className="mx-2">No</b>
										</label>
									</section>
									<br />
									<ErrorMessage
										name="utility.extinguisher"
										render={renderError}
									/>
								</div>
								<div role="group" aria-labelledby="area-radio-group">
									<section>
										<h5>Alternative Power</h5>
										Is there an alternative source of power?
										<br />
										<label className="label-spacing">
											<Field type="radio" name="utility.altPower" value={"3"} />
											<b className="mx-2">Yes</b>
										</label>
										<label className="label-spacing">
											<Field type="radio" name="utility.altPower" value={"0"} />
											<b className="mx-2">No</b>
										</label>
									</section>
									<br />
									<ErrorMessage name="utility.altPower" render={renderError} />
								</div>
							</div>
							<div className="col-md-6 col-sm-12">
								<section>Type of Meter</section>
								<label className="label-spacing">
									<Field type="radio" name="utility.meterType" value={"3"} />
									<b className="mx-2">Room-specific</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field type="radio" name="utility.meterType" value={"0"} />
									<b className="mx-2">Shared</b>
								</label>
								<br />
								<ErrorMessage name="utility.meterType" render={renderError} />
							</div>
						</div>
						<div className="row mt-2">
							<div className="col-md-6 col-sm-12">
								<section>
									<h6>WATER SUPPLY</h6>
									Source of Water <br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="utility.waterSupply.waterSource"
											value={"4"}
										/>
										<b className="mx-2">
											Mechanized borehole available with machine pump and
											reserviour
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="utility.waterSupply.waterSource"
											value={"2"}
										/>
										<b className="mx-2">
											Manual borehole available without machine pump and
											reserviour
										</b>
									</label>
									<label className="label-spacing">
										<Field
											type="radio"
											name="utility.waterSupply.waterSource"
											value={"1"}
										/>
										<b className="mx-2">Ghana Water</b>
									</label>
									<br />
								</section>
							</div>
							<div className="col-md-6 col-sm-12">
								<section>Reliability of Water</section>
								<label className="label-spacing">
									<Field
										type="radio"
										name="utility.waterSupply.reliability"
										value={"2"}
									/>
									<b className="mx-2">Very reliable supply</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="utility.waterSupply.reliability"
										value={"1"}
									/>
									<b className="mx-2">Somehow reliable</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="utility.waterSupply.reliability"
										value={"0.5"}
									/>
									<b className="mx-2">Erratic/unreliable water supply</b>
								</label>
								<br />
							</div>
						</div>
						<div className="row mt-3 mb-5">
							<div className="col-md-6 col-sm-12">
								<section>Payment of Electricity</section>
								<label className="label-spacing">
									<Field
										type="radio"
										name="utility.electricityPayment"
										value={"4"}
									/>
									<b className="mx-2">Fully by hostel</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="utility.electricityPayment"
										value={"2"}
									/>
									<b className="mx-2">Shared between hostel and tenants</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="utility.electricityPayment"
										value={"0"}
									/>
									<b className="mx-2">Fully by tenants</b>
								</label>
								<br />
							</div>
						</div>
					</FormikStep>
					<FormikStep>
						<h2>SERVICES</h2>
						<div className="row">
							<div className="col-md-6 col-sm-12">
								<div>
									<section>Porter</section>
									<label className="label-spacing">
										<Field type="radio" name="services.porters" value={"3"} />
										<b className="mx-2">Day and Night</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="services.porters"
											value={"1.50"}
										/>
										<b className="mx-2">Day only</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field type="radio" name="services.porters" value={"1.5"} />
										<b className="mx-2">Night only</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field type="radio" name="services.porters" value={"0"} />
										<b className="mx-2">No Porter</b>
									</label>
									<br />
								</div>
							</div>
							<div className="col-md-6 col-sm-12">
								<section>Security Personnel</section>
								<label className="label-spacing">
									<Field
										type="radio"
										name="services.securityPersonnel"
										value={"4"}
									/>
									<b className="mx-2">Day and Night</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="services.securityPersonnel"
										value={"2"}
									/>
									<b className="mx-2">Day only</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="services.securityPersonnel"
										value={"2"}
									/>
									<b className="mx-2">Night only</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="services.securityPersonnel"
										value={"0"}
									/>
									<b className="mx-2">No Security Personnel</b>
								</label>
								<br />
							</div>
						</div>
						<div className="row my-5">
							<div className="col-md-6 col-sm-12">
								<section>Manager(s)</section>
								<label className="label-spacing">
									<Field type="radio" name="services.managers" value={"3"} />
									<b className="mx-2">Manager not owner ?</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field type="radio" name="services.managers" value={"1.5"} />
									<b className="mx-2">Manager same as owner</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field type="radio" name="services.managers" value={"0"} />
									<b className="mx-2">Manager is same as Porter</b>
								</label>
								<br />
							</div>
							<div className="col-md-6 col-sm-12">
								<section>Cleaners</section>
								<label className="label-spacing">
									<Field
										type="radio"
										name="services.cleaners.satisfactory"
										value={"4"}
									/>
									<b className="mx-2">
										Satisfactory for cleaning both common places (compound,
										corridors etc.) and rooms ?
									</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="services.cleaners.satisfactory"
										value={"2"}
									/>
									<b className="mx-2">
										Satisfactory cleaning for only common places (compound,
										corridors etc) ?
									</b>
								</label>
								<br />
								<label className="label-spacing">
									<Field
										type="radio"
										name="services.cleaners.satisfactory"
										value={"0"}
									/>
									<b className="mx-2">Poor Satisfactory ?</b>
								</label>
								<br />
							</div>
						</div>
					</FormikStep>
					<FormikStep>
						<h5 className="text-center">Extra Services</h5>
						<div className="row">
							<div className="col-md-6 col-sm-12">
								<div role="group" aria-labelledby="specific-tv-radio-group">
									<h5>Air Conditioner</h5>
									<section>Is there an air-conditioner in the room?</section>
									<div className="d-flex">
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.airConditioner"
												value={"1.5"}
											/>
											<b className="mx-2">Yes</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.airConditioner"
												value={"0"}
											/>
											<b className="mx-2">No</b>
										</label>
										<br />
									</div>
								</div>
								<div
									className="mt-4"
									role="group"
									aria-labelledby="specific-tv-radio-group"
								>
									<h5>Room Specific TVs</h5>
									<section>
										Does your room have a TV provided by the hostel?
									</section>
									<div className="d-flex">
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.roomspecificTV"
												value={"1.5"}
											/>
											<b className="mx-2">Yes</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.roomspecificTV"
												value={"0"}
											/>
											<b className="mx-2">No</b>
										</label>
										<br />
									</div>
								</div>
							</div>
							<div className="col-md-6 col-sm-12">
								<h5>Fridges</h5>
								<div role="group" aria-labelledby="specific-tv-radio-group">
									<section>
										Does your room have a fridge provided by the hostel?
									</section>
									<div className="d-flex">
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.fridges"
												value={"2"}
											/>
											<b className="mx-2">Yes</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.fridges"
												value={"0"}
											/>
											<b className="mx-2">No</b>
										</label>
										<br />
									</div>
								</div>
							</div>
						</div>
						<div className="row my-5">
							<div className="col-md-6 col-sm-12">
								<div role="group" aria-labelledby="specific-tv-radio-group">
									<section>Provision of Gas Cylinders</section>
									<div>
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.gasCylinder"
												value={"1"}
											/>
											<b className="mx-2">Common Kitchen with Gas Cylinders</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.gasCylinder"
												value={"0"}
											/>
											<b className="mx-2">Room Kitchen with Gas Cylinders</b>
										</label>
										<br />
									</div>
								</div>
							</div>
							<div className="col-md-6 col-sm-12">
								<div role="group" aria-labelledby="specific-tv-radio-group">
									<h5>Water Heater</h5>
									<section>
										Is there a functioning water heater in your bathroom?
									</section>
									<div className="d-flex">
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.waterHeater"
												value={"2"}
											/>
											<b className="mx-2">Yes</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.waterHeater"
												value={"0"}
											/>
											<b className="mx-2">No</b>
										</label>
										<br />
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-6 col-sm-12">
								<div role="group" aria-labelledby="specific-tv-radio-group">
									<h5>Supply of Gas</h5>
									<section>Supply of Gas to common Kitchens</section>
									<div className="d-flex">
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.gasSupply"
												value={"1"}
											/>
											<b className="mx-2">Yes</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.gasSupply"
												value={"0"}
											/>
											<b className="mx-2">No</b>
										</label>
										<br />
									</div>
								</div>
							</div>
						</div>
						<div className="row mt-5 mb-3">
							<div className="col-md-6 col-sm-12">
								<div role="group" aria-labelledby="specific-tv-radio-group">
									<p>Supply of cooking stoves</p>
									<div>
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.cookingStove"
												value={"2"}
											/>
											<b className="mx-2">
												Each room has a cooking stove (electric or gas)
											</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.cookingStove"
												value={"1"}
											/>
											<b className="mx-2">
												Common Kitchens with Cooking Stoves (electric or gas)
											</b>
										</label>
										<br />
										<label className="label-spacing">
											<Field
												type="radio"
												name="extraServices.cookingStove"
												value={"0"}
											/>
											<b className="mx-2">No Stove</b>
										</label>
										<br />
									</div>
								</div>
							</div>
							<div className="col-md-6 col-sm-12">
								<section>Paid TV Channel</section>
								<div role="group" aria-labelledby="paid-tv-channel-group">
									<label className="label-spacing">
										<Field
											type="radio"
											name="extraServices.paidTVChannel"
											value={"2"}
										/>
										<b className="mx-2">
											DSTV Available to rooms and common TV rooms ?
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="extraServices.paidTVChannel"
											value={"1.5"}
										/>
										<b className="mx-2">
											DSTV available only at common TV Rooms
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="extraServices.paidTVChannel"
											value={"1"}
										/>
										<b className="mx-2">
											Other service providers available to rooms and common TV
											rooms?
										</b>
									</label>
									<label className="label-spacing">
										<Field
											type="radio"
											name="extraServices.paidTVChannel"
											value={"0.5"}
										/>
										<b className="mx-2">
											Other service providers available only at common TV rooms?
										</b>
									</label>
									<br />
									<label className="label-spacing">
										<Field
											type="radio"
											name="extraServices.paidTVChannel"
											value={"0"}
										/>
										<b className="mx-2">No paid TV Channels</b>
									</label>
									<br />
								</div>
							</div>
						</div>
					</FormikStep>
				</FormStepper>
			</div>
		</>
	);
}

export function FormikStep({ children }) {
	return <>{children}</>;
}

export function FormStepper({ children, ...props }) {
	const childrenArray = React.Children.toArray(children);
	const [step, setStep] = useState(0);
	// const [isSubmitting, setSubmit] = useState(false);
	// const [completed, setCompleted] = useState(false);
	const currentChild = childrenArray[step];

	function isLastPage() {
		return step === childrenArray.length - 1;
	}

	return (
		<Formik
			{...props}
			validationSchema={currentChild.props?.validationSchema}
			onSubmit={async (values, { resetForm }) => {
				if (isLastPage()) {
					props.onSubmit(values, resetForm);
				} else {
					setStep((s) => s + 1);
				}
			}}
		>
			<Form>
				<ToastContainer className="top-margin" />
				{currentChild}

				{step > 0 ? (
					<button
						type="button"
						style={{ marginRight: 12 }}
						onClick={() => setStep((s) => s - 1)}
						className="btn mb-5 px-3 py-2"
					>
						Back
					</button>
				) : (
					""
				)}
				<button type="submit" className="btn mb-5  py-2 px-3">
					{isLastPage() ? "Submit" : "Next"}
				</button>
			</Form>
		</Formik>
	);
}
